
import React from 'react';
import { TaskImageUpload } from './TaskImageUpload';
import { TaskImageGallery } from './TaskImageGallery';
import { useQueryClient } from '@tanstack/react-query';

type TaskImagesProps = {
  taskId: string;
};

export const TaskImages = ({ taskId }: TaskImagesProps) => {
  const queryClient = useQueryClient();

  const handleUploadComplete = () => {
    queryClient.invalidateQueries({ queryKey: ['task-images', taskId] });
  };

  return (
    <div className="space-y-6">
      <TaskImageUpload 
        taskId={taskId} 
        onUploadComplete={handleUploadComplete}
      />
      <TaskImageGallery taskId={taskId} />
    </div>
  );
};
